import gql from 'graphql-tag';

const EVENTS_TARGET = gql`
  query eventsTarget($where: EventsTargetWhereUniqueInput!) {
    eventsTarget(where: $where) {
      id
      name
      eventTags {
        appId
      }
      cart
      tag
      pageViews
      signups
      transactions
      total
      basketItems
      sessions
      impressions
      tagUpdateDate
      testLogs {
        id
        testDate
        pageViews
        total
        signups
        transactions
        basketItems
        sessions
        impressions
        retailIds {
          retailId
          pageViews
          signups
          transactions
          total
          sessions
          impressions
        }
      }
      orgs {
        id
        name
        domain
        tagDomain
        level
        parentOrg {
          id
          level
          tagDomain
        }
      }
      isDisabled
      isSignUps
      isCommerce
      isPublisherDomain
      domain
      isAdvertiser
      impressionEnvironments
      dsp
      type
      dspTracking
      thirdPartyTag
      orgAdvertiserId
      s3_pv
      s3_tr
    }
  }
`;

export default EVENTS_TARGET;
